module.exports = __webpack_public_path__ + "media/images/countrysquared/gs-8d94f028a03bff35a1b08b9ddaf29014.svg";